import React from 'react'
import { Tag } from 'antd'

const OrderType = (props) => {
  const { orderType, orderTypeDescr } = props
  if (orderType === 'PAR') return (<Tag>{orderTypeDescr}</Tag>)
  if (orderType === 'DSB') return (<Tag>{orderTypeDescr}</Tag>)
  return null
}
export default OrderType
